const protocolOf = () => {
  const protocol = process.browser
    ? window.location.protocol
    : process.env.NODE_ENV === 'production'
    ? 'https:'
    : 'http:';
  return protocol;
};
export default protocolOf;
